export default "__VITE_ASSET__ByIFvWsF__"